import script from "./InvoicesQuery.vue?vue&type=script&lang=js"
export * from "./InvoicesQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__